import React from 'react';
import { clsx } from 'clsx';

interface BadgeProps {
  variant?: 'default' | 'destructive' | 'warning' | 'success' | 'primary';
  size?: 'sm' | 'md';
  className?: string;
  children: React.ReactNode;
}

export const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  size = 'md',
  className,
  children
}) => {
  const baseClasses = 'inline-flex items-center rounded-full font-medium';
  
  const variantClasses: Record<NonNullable<BadgeProps['variant']>, string> = {
    default:     'bg-secondary text-secondary-foreground',
    destructive: 'bg-destructive/10 text-destructive',
    warning:     'bg-warning/15 text-warning',
    success:     'bg-success/10 text-success',
    primary:     'bg-primary/10 text-primary',
  };
  
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-2.5 py-0.5 text-sm'
  };

  return (
    <span className={clsx(baseClasses, variantClasses[variant], sizeClasses[size], className)}>
      {children}
    </span>
  );
};